import { render, staticRenderFns } from "./collection-record-export.vue?vue&type=template&id=effcb574&scoped=true"
import script from "./collection-record-export.vue?vue&type=script&lang=ts"
export * from "./collection-record-export.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effcb574",
  null
  
)

export default component.exports